/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from './BaseApi';
import type {ModulesApi as Contract, ModulesList, SrcDocOptions} from '@adobe/exc-app/modules';
import {Events} from '@exc/shared';

export class ModulesApi extends BaseApi implements Contract {
  protected apiEvents: string[] = ['modules'];
  protected defaultType = 'modules';
  protected event = Events.MODULES_DATA;
  public get = this.handler<string | string[], ModulesList>('GET') as (module?: string | string[]) => Promise<ModulesList>;
  protected keyPrefix = 'modules';

  public getSrcDoc(options: SrcDocOptions): Promise<string> {
    return this.sendAndReceive<string>(Events.SPA_SRC_DOC, {data: options, method: 'GET', type: this.defaultType});
  }
}
